module.exports = __webpack_public_path__ + "static/img/JJ.95d1fe59.png";